import PropTypes from 'prop-types'
import React from 'react'

const PageBase = ({ style = '', showGenericBG = false, children }) => {
  let bgStyle = ' '

  if (showGenericBG) {
    bgStyle = ' page-base-bg '
  }
  const styleName = bgStyle + style

  return <div className={styleName}>{children}</div>
}

PageBase.propTypes = {
  theme: PropTypes.string,
  style: PropTypes.string,
  showGenericBG: PropTypes.bool,
  children: PropTypes.node,
}

export default PageBase
